;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="3a6e05d9-5d3c-4db7-b4e1-84e64a36cbce",e._sentryDebugIdIdentifier="sentry-dbid-3a6e05d9-5d3c-4db7-b4e1-84e64a36cbce")}catch(e){}}();import axios from 'axios';
import Cookies from '../../../node_modules/.pnpm/js-cookie@2.2.1/node_modules/js-cookie/src/js.cookie.js';
import { useContext } from 'react';
import AppContext from '../../../context/AppContext.js';
import '../../../_virtual/_sentry-release-injection-file.js';
import { withSentryHub } from '../../../utils/sentry.js';

const SUGGESTION_API_OPTIONS = {
    headers: {
        'X-Caller': 'shop-header',
    },
};
function convertCategory(categoryJson, term, translations, languagePrefix) {
    const { parentCategoryTitle: parentGroupTitle, categoryTitle: groupTitle, count, path, } = categoryJson;
    const separator = translations.get('shop.header.search.autocomplete.separator');
    const title = parentGroupTitle
        ? `${groupTitle} ${separator} ${parentGroupTitle}`
        : groupTitle;
    const encodedSearchPath = encodeURIComponent(path);
    return {
        url: `${languagePrefix}/search/results?ct=${encodedSearchPath}&q=${term}`,
        title,
        count: count.toString(),
    };
}
function convertProduct(productJson) {
    const { path: url, pictureUrl: picture, name: title, isSponsored, } = productJson;
    return { url, title, picture, isSponsored };
}
function convertPage(pageJson) {
    const { targetUrl: url, display: title } = pageJson;
    return { url, title };
}
function convertSuggestions(term, responseJson, translations, languagePrefix) {
    const suggestionItems = [];
    if (responseJson.categories) {
        suggestionItems.push({
            type: 'CATEGORY',
            items: responseJson.categories.map((data) => convertCategory(data, term, translations, languagePrefix)),
        });
    }
    if (responseJson.products) {
        suggestionItems.push({
            type: 'PRODUCT',
            items: responseJson.products.map((data) => convertProduct(data)),
        });
    }
    if (responseJson.pages) {
        suggestionItems.push({
            type: 'SERVICE',
            items: responseJson.pages.map((data) => convertPage(data)),
        });
    }
    return {
        suggestionItems,
        redirectUri: responseJson.redirectUri || null,
    };
}
function getLanguagePrefix(selectedShopLanguage) {
    if (typeof selectedShopLanguage !== 'undefined') {
        return selectedShopLanguage === 'fr' ? '/fr' : '';
    }
    return '';
}
function useSuggestSearchSupport() {
    const { hoppsSuggestionsUrl, translations, selectedShopLanguage } = useContext(AppContext);
    const languagePrefix = getLanguagePrefix(selectedShopLanguage);
    function redirectToSearchResults(term) {
        if (term.length > 0) {
            const encodedTerm = encodeURIComponent(term);
            window.location =
                `${languagePrefix}/search/results?q=${encodedTerm}`;
        }
    }
    function populateRvpsId(ztNav) {
        try {
            const parsed = JSON.parse(ztNav);
            return parsed.map((product) => product.product_id).join(',');
        }
        catch (err) {
            return undefined;
        }
    }
    function redirectToServicePage(url) {
        window.location = url;
    }
    function buildQueryParams(term) {
        const customerId = Cookies.get('cid');
        const sessionId = Cookies.get('sid');
        const rvPsIds = Cookies.get('zt_nav');
        let queryParams = `q=${term}`;
        if (customerId) {
            queryParams += `&customerId=${customerId}`;
        }
        if (sessionId) {
            queryParams += `&sid=${sessionId}`;
        }
        if (rvPsIds) {
            const convertedRvpsIds = populateRvpsId(rvPsIds);
            if (convertedRvpsIds) {
                queryParams += `&rvPsIds=${convertedRvpsIds}`;
            }
        }
        return queryParams;
    }
    async function fetchSuggestions(term) {
        const queryParams = buildQueryParams(term);
        try {
            const response = await axios.get(`${hoppsSuggestionsUrl}?${queryParams}`, SUGGESTION_API_OPTIONS);
            if (response.data) {
                return convertSuggestions(term, response.data, translations, languagePrefix);
            }
            return null;
        }
        catch (e) {
            withSentryHub()?.captureException(new Error(`Error fetching suggestions from API: ${e}`), {
                captureContext: (scope) => scope.setTags({ type: 'searchEngineRequest' }),
            });
            return null;
        }
    }
    return { redirectToSearchResults, fetchSuggestions, redirectToServicePage };
}

export { useSuggestSearchSupport };
//# sourceMappingURL=hopps.js.map
